<template>
    <div>
        <v-card style="min-height:300px" v-if="items">
            <v-card-text v-show="items.length">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    item-key="id"
                    disable-initial-sort
                    hide-actions
                >
                    <template slot="items" slot-scope="props">
                    <tr>
                        <!-- <td style="padding:1px;margin:1px">
                            <v-btn large @click.prevent="onPicked(props.item)" class="primary" style="padding:1px;margin:1px">
                                <v-icon medium dark v-show="props.item.sellingRankNum < 4">thumb_up</v-icon>
                                Pick
                            </v-btn>
                        </td> -->
                        <td style="padding: 1px 1px;">
                            <v-img
                                :src="props.item.imgThumbnailUrl"
                                height="100"
                                width="100"
                                
                            ></v-img>
                        </td>
                        <td class="text-xs-center" style="padding: 1px;">
                            <div class="">
                                {{ props.item.itemClass }}
                            </div>
                        </td>
                        <td class="text-xs-left" style="padding: 1px;">
                            <div class="">
                                {{ props.item.catalogNum }}
                            </div>
                        </td>
                        <td class="text-xs-left" style="padding: 1px;">
                            <div>
                                {{ props.item.itemDesc }}
                            </div>
                        </td>
                        <td style="width:150px; padding: 1px;">
                            <!-- {{ props.item.sellingRank }} -->
                            <v-layout>
                                <v-flex text-xs-center>
                                    <v-icon mediam v-show="props.item.sellingRank=='NEW'">fiber_new</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-rating
                            v-model="props.item.sellingRankNum"
                            color="yellow darken-3"
                            background-color="grey darken-1"
                            empty-icon="$vuetify.icons.ratingFull"
                            half-increments
                            hover
                            small
                            :dense="true"
                            :readonly="true"
                            ></v-rating>

                        </td>
                        <td class="text-xs-left" style="padding: 1px;">
                            <v-layout v-for="(doc, idx) in props.item.productUrlList" :key="idx">
                                <v-flex xs12 v-if="doc.url != ''">
                                    <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                        {{doc.name}}
                                    </a>
                                </v-flex>
                            </v-layout>                        
                        </td>
                        <!-- <td class="text-xs-left" style="padding: 1px;">
                            <v-layout v-for="(doc, idx) in props.item.brochureList" :key="idx">
                                <v-flex xs12 v-if="doc.url != ''">
                                    <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                        {{doc.name}}</a>
                                     (page {{doc.atPage}})
                                </v-flex>
                            </v-layout>                        
                        </td>
                        <td class="text-xs-center" style="padding: 1px;">
                            <v-layout v-for="(doc, idx) in props.item.ifuList" :key="idx">
                                <v-flex xs12 v-if="doc.url != ''">
                                    <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                        IFU</a>
                                </v-flex>
                            </v-layout>                        
                        </td>
                        <td class="text-xs-center" style="padding: 1px;">
                            <v-layout v-for="(doc, idx) in props.item.memoList" :key="idx">
                                <v-flex xs12 v-if="doc.url != ''">
                                    <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                        MEMO</a>
                                </v-flex>
                            </v-layout>                        
                        </td>
                        <td class="text-xs-center" style="padding: 1px;">
                            <v-layout v-for="(doc, idx) in props.item.sdsList" :key="idx">
                                <v-flex xs12 v-if="doc.url != ''">
                                    <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                        SDS</a>
                                </v-flex>
                            </v-layout>                        
                        </td>
                        <td class="text-xs-center" style="padding: 1px;">
                            <v-layout v-for="(doc, idx) in props.item.priceList" :key="idx">
                                <v-flex xs12 v-if="doc.url != ''">
                                    <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                        {{doc.name}}</a>
                                     (page {{doc.atPage}})
                                </v-flex>
                            </v-layout>                        
                        </td> -->
                        <!-- <td style="padding: 1px;">
                            <table>
                                <thead>
                                    <tr style="height: 10px;">
                                        <th style="padding: 1px; margin: 1px; height: 10px;">Price</th>
                                        <th style="padding: 1px; margin: 1px; height: 10px;">Unit</th>
                                        <th style="padding: 1px; margin: 1px; height: 10px;">Qty. Range</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="itemPrice in props.item.prices" :key="itemPrice.itemPriceId">
                                        <td style="padding: 3px 1px;">{{itemPrice.uofmPrice | toCurrency}}</td>
                                        <td style="padding: 3px 1px;" nowrap><span>{{itemPrice.uofm}}</span></td>
                                        <td style="padding: 3px 1px;" nowrap>{{itemPrice.fromQty}} - {{itemPrice.toQty == '999999999999'?'any' : itemPrice.toQty}}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </td> -->
                    </tr>
                    <!-- <tr v-for="itemPrice in props.item.prices" :key="itemPrice.itemPriceId">
                        <td>{{itemPrice.uofmPrice | toCurrency}}</td>
                        <td>{{itemPrice.uofm}}</td>
                        <td>{{itemPrice.fromQty}} - {{itemPrice.toQty == '999999999999'?'any' : itemPrice.toQty}}</td>

                    </tr> -->
                    </template>
                </v-data-table>  
            </v-card-text>
        </v-card>
        <!-- {{items}} -->
    </div>
</template>
<script>
// import _ from "lodash"
import ctlItemAdvancedSearchFilter from '@/components/ctlItemAdvancedSearchFilter'
import { mapActions } from 'vuex'

export default {
    props: ['items'],
    components: {
        'ctlItemAdvancedSearchFilter':ctlItemAdvancedSearchFilter
    },
    data () {
        return {
            // formValid : false,
            // keyword : '',
            // minCharsToSearch : 3,
            // rules: {
            //     required: v => !! v || 'This field is required'
            // },
            // items: [],
            // pagination: {
            //     descending: true,
            //     page: 1,
            //     rowsPerPage: 10,
            //     sortBy: '',
            //     totalItems: 0,
            //     rowsPerPageItems: [10, 20, 50]
            // },
            headers: [
                {},
                {text: 'Class', sortable: false, value: 'itemClass'},
                // {text: 'Item #', sortable: false, value: 'itemCode'},
                {text: 'Catalog #', sortable: false, value: 'catalogNum'},
                {text: 'Name', sortable: false, value: 'itemDesc'},
                {text: 'Selling Rank', sortable: false, value: 'sellingRank'},
                {text: 'Product Page (IFU, MEMO, SDS ...)', sortable: false, value: '', align: 'center'},
                // {text: 'Brochure', sortable: false, value: ''},
                // {text: 'IFU', sortable: false, value: ''},
                // {text: 'MEMO', sortable: false, value: ''},
                // {text: 'SDS', sortable: false, value: ''},
                // {text: 'Price List', sortable: false, value: ''},
                // 20251212, stop show price after move to SAP
                // {text: 'GP Price', sortable: false, value: '', align: 'center'},
                // {text: 'Unit', sortable: false, value: ''},
                // {text: 'Qty. Range', sortable: false, value: ''},
            ],
        }
    },
    computed: {
        keywordFieldHint () {
            return `Need at least ${this.minCharsToSearch} characters to start search`
        }
    },
    methods: {
        // ...mapActions('itemSearch',[
        //     'searchItemAdvanced'
        // ]),
        onPicked(itemPicked) {
            this.$emit('onItemPicked', itemPicked)
            // reset data
            // this.keyword = ''
            // this.items = []
        },
        // getRowSpan(item) {
        //     return item.prices == null? 1: item.prices.length
        // }
        // searchItems: _.debounce(async function (val) {
        //             // if (this.searchCriteria.statusSelected === null || this.searchCriteria.statusSelected.length === 0) {
        //             //     alert('Please select at least one status to search')
        //             //     return
        //             // }
        //             // const jtSelected = this.searchCriteria.jobTypeSelected === 0
        //             //     ? this.jobTypes.map(item => item.id)
        //             //     : [this.searchCriteria.jobTypeSelected]
        //             // const payload = Object.assign({}, this.searchCriteria, { jobTypeSelected: jtSelected })
        //             // this.$store.dispatch('jobSearch/searchJobs', payload)
        //             //     .then(data => {
        //             //         this.jobs = data
        //             //         // console.log('jobs' + this.jobs)
        //             //     })
        //     // if(!val || !val.length || val.length < 3)
        //     //     return
        //     if(!val || !val.length)
        //         return
        //     // this.isLoading = true;

        //     let FacilitysFound = await this.searchItemAdvanced({number: val});
        //     // console.log(`FacilitysFound: ${FacilitysFound.length}`)
        //     this.count = FacilitysFound.length
        //     this.items = FacilitysFound

        //     this.$refs.txtItemNo.focus()
        //     // this.isLoading = false
        // }, 10),
    },
    watch: {
        // keyword : function(newVal, oldVal) {
        //     this.searchItems(newVal)
        // }
    }
}
</script>
